import { AxiosRequestConfig } from "axios";
import { CohesiveAPIClient } from "../../client";
import {
  UpdateToolConfirmationPayload,
  UpdateToolConfirmationResponse,
} from "./types";

import { route } from "../../utils";

export * from "./types";

const ENDPOINTS = {
  UPDATE:
    "/api/v1/org/:organization_id/flow-sessions/:flow_session_id/flow-messages/:flow_message_id/tool-calls/:tool_call_id",
};

export class ToolConfirmationsAPI {
  constructor(private client: CohesiveAPIClient) {}

  async update(
    flowSessionId: string,
    flowMessageId: string,
    toolCallId: string,
    data: UpdateToolConfirmationPayload,
    config?: AxiosRequestConfig,
  ): Promise<UpdateToolConfirmationResponse> {
    const organizationId = await this.client.getOrgID();
    const response = await this.client.axios.put<
      UpdateToolConfirmationResponse,
      any,
      UpdateToolConfirmationPayload
    >(
      route(ENDPOINTS.UPDATE, {
        organization_id: organizationId,
        flow_session_id: flowSessionId,
        flow_message_id: flowMessageId,
        tool_call_id: toolCallId,
      }),
      data,
      config,
    );
    return response.data;
  }
}
